import * as rdxConsts from '../redux-infra/rdx-constants';

export const mapStateToProps = (state:any,props:any) => ({...state,...props })